module.exports = __webpack_public_path__ + "img/4-5.d423445a.png";